import http from "../http";
import MetricsService from '../services/metrics.service'; // Add this import

// Create a loading flag outside the store
let isLoadingData = false;

const getDefaultState = () => ({
  countries: [],
  metrics: [],
  units: [],
  isDataLoaded: false,
  dataLoadingError: null,
  latestError: null
});

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setCountries(state, countries) {
            state.countries = countries;
        },
        setMetrics(state, metrics) {
            state.metrics = metrics;
        },
        setUnits(state, units) {
            state.units = units;
        },
        // setWorkActivities(state, workActivities) {
        //     state.workActivities = workActivities;
        // },
        setIsDataLoaded(state, isLoaded) {
            state.isDataLoaded = isLoaded;
        },
        setDataLoadingError(state, error) {
            state.dataLoadingError = error;
            state.latestError = error; // Also update latest error
        },
        setLatestError(state, error) {
            state.latestError = error;
        },
        clearAllData(state) {
            // Reset store to default state
            Object.assign(state, getDefaultState());
        }
    },
    actions: {
        async loadCountriesList({ commit, state }) {
            if (state.countries && state.countries.length > 0) {
                return state.countries;
            }

            try {
                const response = await http.get(`/api/v2/geo/countries`);
                commit('setCountries', response.data);
                return response.data;
            } catch (e) {
                console.error('Error loading countries:', e);
                throw e;
            }
            },
        
        async loadMetricsList({ commit, state }) {
            // Skip if we already have data
            if (state.metrics && state.metrics.length > 0) {
                return state.metrics;
            }
            
            try {
                // Replace direct API call with service call
                const metrics = await MetricsService.getAll();
                commit('setMetrics', metrics);
                return metrics;
            } catch (e) {
                console.error('Error loading metrics:', e);
                throw e;
            }
        },
        
        async loadUnitsList({ commit, state }) {
            // Skip if we already have data
            if (state.units && state.units.length > 0) {
                return state.units;
            }
            
            try {
                const response = await http.get(`/api/Units`);
                commit('setUnits', response.data);
                return response.data;
            } catch (e) {
                console.error('Error loading units:', e);
                throw e;
            }
        },
        
        async loadAllData({ dispatch, commit, state }) {
            // Skip if data is already loaded
            if (state.isDataLoaded) return;
            
            // Skip if already loading - use the external flag
            if (isLoadingData) return;
            
            isLoadingData = true;
            commit('setDataLoadingError', null);
            
            try {
                // Load all data in parallel
                await Promise.all([
                    dispatch('loadCountriesList'),
                    dispatch('loadMetricsList'),
                    dispatch('loadUnitsList'),
                    // dispatch('loadWorkActivitiesList')
                ]);
                
                commit('setIsDataLoaded', true);
            } catch (error) {
                console.error('Error loading data:', error);
                commit('setDataLoadingError', error.message || 'Failed to load data');
                throw error;
            } finally {
                isLoadingData = false;
            }
        },
        
        setLatestError({ commit }, error) {
            commit('setLatestError', error);
        },
        
        clearLatestError({ commit }) {
            commit('setLatestError', null);
        }
    },
    getters: {
        countries: state => state.countries,
        metrics: state => state.metrics,
        units: state => state.units,
        // workActivities: state => state.workActivities,
        isDataLoaded: state => state.isDataLoaded,
        dataLoadingError: state => state.dataLoadingError,
        getLatestError: state => state.latestError,
        getUnitById: state => unitId => unitId ? state.units.find(unit => unit.id === unitId) : '',
    }
};
